import { useMutation } from '@tanstack/vue-query';
import type { AxiosResponse } from 'axios';

import { axios } from '@/helpers/axios';
import { LoggerEventPayload } from '@/types/logger';

export const useLoggerMutation = () => {
  return useMutation<AxiosResponse, unknown, LoggerEventPayload>({
    mutationKey: ['logs'],
    mutationFn: async ({ action, value, path = '' }) => 
      await axios.post('logs', {
        action, value, path,
      }),
  });
};